import App from '../App';
import { Route, Navigate } from "react-router-dom";
import XPComponent from './XPComponent';
import Win98theme from './Win98theme';
import DemoPage1 from './DemoPage1';
import Changelog from './Changelog';
import Blog from './Blog';
import Found from './Found';
import Experimental from './Experimental';
import Login from './Login';
import Signup from './Signup';
import Comments from './Comments';

export const routes = (dark, updateLoginState, userData) => (
  <>
    <Route path="/" element={<App {...{ dark }} />} />

    <Route path="changelog" element={<Changelog {...{ dark }} />} />
    <Route path="blog" element={<Blog {...{ dark }} />} />
    <Route path="found" element={<Found {...{ dark }} />} />
    <Route path="experimental" element={<Experimental {...{ dark }} />} />
    <Route path="login" element={<Login {...{ dark, updateLoginState }} />} />
    <Route path="comments" element={<Comments {...{ dark, userData }} />} />
    <Route path="signup" element={<Signup {...{ dark }} />} />

    <Route path="xpComponent" element={<XPComponent />} />
    <Route path="Win98theme" element={<Win98theme />} />

    <Route path="demoPage1" element={<DemoPage1 />} />

    <Route path="*" element={<Navigate to="/" replace />} />

  </>
);